import React, { useEffect, useState } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { useHistory, useParams } from 'react-router'
import { withTranslation } from 'react-i18next'

import { DigitalVaultAlertsAction, DigitalVaultBinAction, DigitalVaultCategoriesAdministrationAction, DigitalVaultHomeAction, DigitalVaultReportsAction, DigitalVaultSearchAction, DigitalVaultTrackingAction } from '../../actions'
import { LocalStorageService } from '../../../services'
import { DigitalVaultView } from '../../views'

function DigitalVaultAction(props) {
    let { t } = props
    const history = useHistory()
    let { route } = useParams()
    const { search } = useLocation()
    const localStorage = new LocalStorageService()

    const [isLoading, setIsLoading] = useState(true)
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
    const [showErrorRequesting, setShowErrorRequesting] = useState(false)
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
    const [messageError, setMessageError] = useState('')

    const [tabs, setTabs] = useState([
        {
            route: 'home',
            title: t('digitalVaultView.title.home'),
            header: t('digitalVaultView.header.digital.vault'),
            component: DigitalVaultHomeAction
        }, {
            route: 'alerts',
            title: t('digitalVaultView.title.alerts'),
            header: t('digitalVaultView.header.alerts'),
            component: DigitalVaultAlertsAction
        }, {
            route: 'search',
            title: t('digitalVaultView.title.search'),
            header: t('digitalVaultView.title.search'),
            component: DigitalVaultSearchAction
        }, {
            route: 'report',
            title: t('digitalVaultView.title.report'),
            header: t('digitalVaultView.title.report'),
            component: DigitalVaultReportsAction
        }, {
            route: 'tracking',
            title: t('digitalVaultView.title.tracking'),
            header: t('digitalVaultView.title.tracking'),
            component: DigitalVaultTrackingAction
        }, {
            route: 'bin',
            title: t('digitalVaultView.title.bin'),
            header: t('digitalVaultView.title.bin'),
            component: DigitalVaultBinAction
        }
    ])

    const [currentPageNum, setCurrentPageNum] = useState(0)
    const [viewAsCards, setViewAsCards] = useState(true)

    const toggleErrorRequesting = (value, message, time, sendInbox) => {
        setShowErrorRequesting(value)
        setMessageError(message)

        if (value) {
            setTimeout(() => {
                setShowErrorRequesting(false)
                if (sendInbox) {
                    history.push('/')
                }
            }, time)
        }
    }

    const changePage = (pageNumber) => {
        history.push({ pathname: `/digital-vault/${tabs[pageNumber].route}` })
        setCurrentPageNum(pageNumber)
    }

    useEffect(() => {
        setIsLoading(true)
        const localStorageService = new LocalStorageService()
        const user = localStorageService.getLocalStorageItem('user')

        let isUser = false
        const userRoles = localStorage.getLocalStorageItem('user').userMetaData.userRoles

        const { role } = userRoles.find(item => (item.role.groupName === 'hibouDigitalVault' || item.role.key === 'roleHibouAdministrator') && item.role.key !== 'roleHibouDigitalContractNotAccess')
        let updatedTabs = [...tabs]
        if (!role) {
            history.replace('/')
            return
        } else if (role.key !== 'roleHibouDigitalVaultSuscriber') {
            isUser = true
            updatedTabs =
                [
                    {
                        route: 'home',
                        title: t('digitalVaultView.title.home'),
                        header: t('digitalVaultView.header.digital.vault'),
                        component: DigitalVaultHomeAction
                    },
                    {
                        route: 'search',
                        title: t('digitalVaultView.title.search'),
                        component: DigitalVaultSearchAction
                    }, {
                        route: 'report',
                        title: t('digitalVaultView.title.report'),
                        header: t('digitalVaultView.title.report'),
                        component: DigitalVaultReportsAction
                    }, {
                        route: 'alerts',
                        title: t('digitalVaultView.title.alerts'),
                        header: t('digitalVaultView.header.alerts.doc'),
                        hidden: true,
                        component: DigitalVaultAlertsAction
                    }, {
                        route: 'tracking',
                        title: t('digitalVaultView.title.tracking'),
                        header: t('digitalVaultView.title.tracking'),
                        component: DigitalVaultTrackingAction
                    }, {
                        route: 'bin',
                        title: t('digitalVaultView.title.bin'),
                        header: t('digitalVaultView.title.bin'),
                        hidden: false,
                        component: DigitalVaultBinAction
                    }
                ]
            setTabs(updatedTabs)
        }

        // FILTRAR TABS SEGUN EL TIPO DE USUARIO
        let pageName = route
        if (!pageName) {
            pageName = tabs[0]
            history.replace({ pathname: `/digital-vault/${pageName}` })
        }

        if (isUser && pageName == 'alerts') {
            const params = new URLSearchParams(search)
            const documentIdParam = params.get('doc')
            if (!documentIdParam) {
                pageName = tabs[0]
                history.replace({ pathname: `/digital-vault/home` })
            }
        }

        const page = updatedTabs.findIndex(t => t.route === pageName)

        if (page === -1) {
            history.replace({ pathname: `/digital-vault/home` })
            setIsLoading(false)
            return
        }

        // setTabs(filteredTabs)
        setCurrentPageNum(page)
        setIsLoading(false)
    }, [route])

    return (
        <DigitalVaultView
            {...props}
            tabs={tabs}
            currentPageNum={currentPageNum}
            changePage={changePage}
            viewAsCards={viewAsCards}
            setViewAsCards={setViewAsCards}

            isLoading={isLoading}
            toggleLoadingScreen={setIsLoading}
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={setShowLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            messageError={messageError}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={setShowCompletedRequesting}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultAction))